var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5828 14C24.5828 19.5228 20.1056 24 14.5827 24C13.0232 24 11.5471 23.643 10.2316 23.0063C9.747 22.7717 9.15 22.8991 8.8514 23.347C8.5365 23.8193 8.6741 24.4624 9.1807 24.7182C10.8043 25.5381 12.6396 26 14.5827 26C21.2102 26 26.5828 20.6274 26.5828 14C26.5828 7.3726 21.2102 2 14.5827 2C10.0244 2 6.0596 4.5416 4.0283 8.2851L3.9728 7.952L2 8.2808L2.5 11.2808L2.6924 12.4351L3.8027 12.065L6.8027 11.065L6.1702 9.1677L5.7496 9.3079C7.4306 6.1499 10.7556 4 14.5827 4C20.1056 4 24.5828 8.4772 24.5828 14ZM15.1218 9.2522C15.1218 8.5606 14.5534 8 13.8523 8C13.1512 8 12.5828 8.5606 12.5828 9.2522V15.292C12.5828 15.6476 12.733 15.9686 12.9744 16.1965C13.1106 16.3394 13.283 16.4527 13.484 16.5211L16.8721 17.6755C17.5348 17.9013 18.2577 17.5545 18.4866 16.9009C18.7155 16.2472 18.3639 15.5343 17.7012 15.3085L15.1218 14.4296V9.2522Z",
    fill: "#000F30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryClock);
export default __webpack_public_path__ + "static/media/HistoryClock.86e2ddefa94d1cb4a4ba6be6a0a93f04.svg";
export { ForwardRef as ReactComponent };